import {
	type AdminFormI18nPaths,
	pickAdminFormPaths,
} from "../admin-form-editor-i18n-paths";
import { useFormEditorStore } from "../state/form-editor-store";

/**
 * Resolves the active admin locale key tree (ticket vs job) for form-editor UI.
 */
export function useAdminFormEditorPaths(): AdminFormI18nPaths {
	const entity = useFormEditorStore((s) => s.formEditorEntity);
	return pickAdminFormPaths(entity);
}
